// CustomNavigateButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ButtonEdit = ({ to}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to); // Navegar a la ruta proporcionada
  };

  return (
    <button onClick={handleClick} className="text-blue-600 hover:text-green-700">
      <span className="material-icons-outlined">edit</span>
    </button>
  );
};

export default ButtonEdit;
